import { Injectable, inject } from '@angular/core';

import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import {
    SchemaMarkupService,
    SchemaMarkupType,
    SeoGenericSchema,
    SeoItemSchema,
    SeoListItemSchema,
    SeoMarkupConstants,
} from '@frontend/sports/schema-markup/feature';

import { BreadcrumbModel } from './breadcrumb.models';

export class SeoBreadcrumbSchema extends SeoGenericSchema {
    '@context' = SeoMarkupConstants.markupSchemaContext;
    'itemListElement': SeoListItemSchema[];

    'constructor'(itemListElement: SeoListItemSchema[]) {
        super(SchemaMarkupType.BreadcrumbList);
        this.itemListElement = itemListElement;
    }
}

@Injectable({ providedIn: 'root' })
export class BreadCrumbSchemaMarkupService {
    schemaMarkupService: SchemaMarkupService = inject(SchemaMarkupService);
    urlHelper = inject(UrlHelperService);

    addBreadcrumbSchemaMarkup(breadcrumbs: BreadcrumbModel[]): void {
        if (breadcrumbs && breadcrumbs.length > 0) {
            const scriptElement = this.schemaMarkupService.addGenericSchemaMarkup(SchemaMarkupType.BreadcrumbList);
            scriptElement.text = this.generateBreadcrumbSchema(breadcrumbs);
            if (scriptElement.text) {
                this.schemaMarkupService.addSchemaMarkupScriptToBody(SchemaMarkupType.BreadcrumbList, scriptElement);
            }
        }
    }

    private generateBreadcrumbSchema(breadcrumbs: BreadcrumbModel[]): string {
        const listItemSchema: SeoListItemSchema[] = breadcrumbs
            .filter((crumb) => crumb.url)
            .map((crumb, index) => {
                return new SeoListItemSchema(new SeoItemSchema(this.urlHelper.getAbsolute(this.urlHelper.getUrl(crumb.url))), crumb.title, index);
            });

        if (listItemSchema.length > 0) {
            const breadCrumbsSchema = new SeoBreadcrumbSchema(listItemSchema);

            return this.schemaMarkupService.generateLdJson(breadCrumbsSchema);
        }

        return '';
    }
}
